import { render, staticRenderFns } from "./ListClients.vue?vue&type=template&id=a873ce4e"
import script from "./ListClients.vue?vue&type=script&lang=js"
export * from "./ListClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports